<table ng-if="changes.length" class="changes">
    <thead>
    <tr>
        <th>{{'activityLog.fieldName'|translate}}</th>
        <th>{{'activityLog.oldValue'|translate}}</th>
        <th>{{'activityLog.newValue'|translate}}</th>
    </tr>
    </thead>
    <tr ng-repeat="i in changes">
        <td ng-if="i.FieldDisplayName" title="{{i.FieldDisplayName|translate}}">{{i.FieldDisplayName|translate}}</td>
        <td ng-if="i.PropertyName" title="{{i.PropertyName|translate}}">{{i.PropertyName|translate}}</td>
        <td title="{{i.OldValue}}{{i.OldDate}}">
            {{i.OldValue| limitTo: limit }}{{i.OldValue.length > 70 ? '...' : ''}}
            {{i.OldDate| limitTo: limit }}{{i.OldDate.length > 70 ? '...' : ''}}
        </td>
        <td title="{{i.NewValue}}{{i.NewDate}}">
            {{i.NewValue| limitTo: limit }}{{i.NewValue.length > 70 ? '...' : ''}}
            {{i.NewDate| limitTo: limit }}{{i.NewDate.length > 70 ? '...' : ''}}
        </td>
    </tr>
</table>
<span class="status" ng-if="!changes.length">{{status}}</span>